<template>
    <div class="external-page external-alt sb-l-c sb-r-c">
        <div id="main" class="animated fadeIn">
            <section id="content_wrapper">
                <section id="content">

                    <div class="admin-form theme-info mw500" id="">
                        <h1>{{ code }} <small>{{codeText}}</small></h1>
                        <div class="panel mt30 mb25 p15">
                            <pre v-html="message" v-if="message.length > 0"></pre>
                            <pre v-html="trace" v-if="trace.length > 0"></pre>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>


<script>
    export default {
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.code = to.params.code;
                vm.codeText = to.params.codeText;
                vm.message = to.params.message;
                vm.trace = to.params.trace;
            });
        },
        data() {
            return {
                code: 500,
                codeText: '',
                message: '',
                trace: '',
            };
        },
        metaInfo() {
            return {
                title: this.code,
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
